export default __webpack_public_path__ + "static/flag-gb-1434f86cb70b08306592d74cf30704dd.svg";